export default __webpack_public_path__ + "static/media/cheesecake.65c0adcf.jpg";